export const isColliding = (firstElement, secondElement) => {
    const firstElementRect = firstElement?.getBoundingClientRect();
    const secondElementRect = secondElement?.getBoundingClientRect();

    if (!firstElementRect || !secondElementRect) {
        return false;
    }

    return !(firstElementRect.right < secondElementRect.left ||
        firstElementRect.left > secondElementRect.right ||
        firstElementRect.bottom < secondElementRect.top ||
        firstElementRect.top > secondElementRect.bottom)
}